enum SourceType {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
}

export default SourceType;
